import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { BaseRepository } from '@common/data/base';
import { environment } from '@environment/environment';
import { ApiResources } from '@constants/api-resources';
import { CampoObrigatorioAPI, PortalClienteAPI } from './dto/get-portal-cliente.dto';
@Injectable({
  providedIn: 'root' 
})
export class PortalClienteRepository extends BaseRepository {
  constructor(http: HttpClient) {
    super(http, environment.serverAuthUrl, ApiResources.PORTALCLIENTE);
  }

  getCamposObrigatorios(search: string = ''): Observable<any[]> {
    return this.getRequest<{ data: { results: any[]; count: number } }>({
      search,
      page: 1,
      offset: 0,
      limit: 1, 
    }).pipe(
      map(({ data } : any) => data.camposObrigatorios || [])
    );
  }
}